if (!window.__nmyEmbosserSalesReady) {
  window.__nmyEmbosserSalesReady = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-nmy-purchase-link]');
    if (!trigger) return;

    var target = document.querySelector('[id^="ProductInfo-"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
}

/* ---- NMY sticky buy bar (sections/nmy-embosser-sticky.liquid) ----
   Hidden while any buy/CTA button is on screen, visible otherwise.
   Never adds to cart without the personalised name. */
(function () {
  if (window.__nmyStickyReady) return;
  function init() {
    var bar = document.querySelector('[data-nmy-sticky]');
    if (!bar || window.__nmyStickyReady) return;
    window.__nmyStickyReady = true;
    if (!('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('[data-nmy-sticky-btn]');
    var SEL = '.nmy-sales-button, [data-nmy-purchase-link], [id^="MainProduct-"] [name="add"], [data-nmb-card], quantity-breaks';
    if (bar.getAttribute('data-hide-footer') === 'true') SEL += ', footer.footer, .footer';
    var seen = new Set();
    var inView = new Set();

    function update() {
      var show = inView.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) inView.add(e.target); else inView.delete(e.target);
      });
      update();
    });
    function watch() {
      document.querySelectorAll(SEL).forEach(function (el) {
        if (seen.has(el) || bar.contains(el)) return;
        seen.add(el); io.observe(el);
      });
      // drop nodes the theme removed (variant re-render replaces the add button)
      seen.forEach(function (el) {
        if (!document.contains(el)) { io.unobserve(el); seen.delete(el); inView.delete(el); }
      });
    }
    watch();
    var main = document.querySelector('[id^="MainProduct-"]');
    if (main && 'MutationObserver' in window) {
      new MutationObserver(function () { watch(); update(); }).observe(main, { childList: true, subtree: true });
    }

    // live price for the chosen variant
    var prices = {};
    try { prices = JSON.parse(bar.querySelector('[data-nmy-sticky-variants]').textContent); } catch (_) {}
    var nowEl = bar.querySelector('[data-nmy-sticky-now]');
    var wasEl = bar.querySelector('[data-nmy-sticky-was]');
    function productForm() {
      return document.querySelector('[id^="MainProduct-"] form[action*="/cart/add"][data-type="add-to-cart-form"]') ||
        document.querySelector('[id^="MainProduct-"] form[action*="/cart/add"]');
    }
    function syncPrice() {
      var f = productForm(); var idEl = f && f.querySelector('[name="id"]');
      var p = idEl && prices[idEl.value];
      if (!p || !nowEl) return;
      nowEl.textContent = p[0];
      if (wasEl) { wasEl.hidden = !p[1]; if (p[1]) wasEl.textContent = p[1]; }
    }
    document.addEventListener('change', function () { setTimeout(syncPrice, 60); }, true);
    document.addEventListener('variant:change', syncPrice);

    function smooth() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    function goToName() {
      var root = document.querySelector('[data-nmb]');
      var card = root && root.querySelector('[data-nmb-card]');
      var input = root && root.querySelector('[data-nmb-input]');
      if (!card) return false;
      card.classList.add('nmb-open');
      card.scrollIntoView({ behavior: smooth(), block: 'center' });
      return true;
    }
    function goToBuy() {
      var add = document.querySelector('[id^="MainProduct-"] [name="add"]');
      var t = add || document.querySelector('[id^="ProductInfo-"]') || productForm();
      if (t) t.scrollIntoView({ behavior: smooth(), block: add ? 'center' : 'start' });
      return add;
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!goToName()) goToBuy();                        // always: open the name box in the buy area
    });
    if (!seen.size) update();   // no targets at all: show; otherwise the observer's first callback decides
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
